/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import TabHome from './myCloudBody';
import Urls from '../../../utils/urls';

import BaseUrls from '../../../utils/baseUrls';
import { prefixPath } from '../../../utils/helpers';
import apiBackendInstance from '../../../utils/axios';

interface cloud {
  id: string,
  name: string,
}

const MyCloud = () => {
  const [cloudTab, setCloudTab] = useState([] as cloud[] | []);

  const cid = '2051b7e0-0210-47e9-870f-76162f49ebf9';
  const digitalId = '6cd1b682-bfe7-414c-9e4c-8ab8f8b20ac6';
  const [cloudId, setCloudId] = useState(cid);
  const [cloudName, setCloudName] = useState('aws');
  const tempData: cloud[] = [{ id: cid, name: 'AWS' },
    { id: digitalId, name: 'Digitalocean' },
    {
      id: 'c4ba9fa8-8fc3-4005-a837-6fa34df26ab7',
      name: 'GCP',
    },
    {
      id: '2ca3821c-864e-4a11-8280-6326db48f28c',
      name: 'Tencent',
    },
  ];

  const theme = BaseUrls.getkey();
  const baseUrl = window.location.origin;
  const awsImg = baseUrl + prefixPath(`/img/${theme}/AWS Cloud.png`);
  const digitalOceanImg = baseUrl + prefixPath(`/img/${theme}/DigitalOcean Cloud.png`);
  const gcpImg = baseUrl + prefixPath(`/img/${theme}/GCP Cloud.png`);
  const tencentImg = baseUrl + prefixPath(`/img/${theme}/tencent-cloud-small.png`);

  const getImage = (str: string) => {
    switch (str.toLowerCase()) {
      case 'aws': return awsImg;
      case 'digital ocean': return digitalOceanImg;
      case 'digitalocean': return digitalOceanImg;
      case 'gcp': return gcpImg;
      case 'tencent': return tencentImg;
      default: return '';
    }
  };
  useEffect(() => {
    let isActive = true;
    apiBackendInstance.get(Urls.getCloudList(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (isActive && response.data && response.data.success) {
        const { data } = response.data;
        data.sort((a:cloud, b:cloud) => a.name.localeCompare(b.name));
        setCloudTab(data);
      }
    }).catch((err) => {
      tempData.sort((a:cloud, b:cloud) => a.name.localeCompare(b.name));
      setCloudTab(tempData);
      console.error(err);
    });
    return () => { isActive = false; };
  }, []);
  const setCloudInfo = (id:string, name:string) => {
    setCloudId(id);
    setCloudName(name.toLowerCase().trim());
  };
  const setCloudData = () => <TabHome id={cloudId} cloudName={cloudName} />;
  const setDisable = (str: string) => {
    if (str.toLowerCase().trim() === 'aws' || str.toLowerCase().trim() === 'digitalocean' || str.toLowerCase().trim() === 'gcp'
    || str.toLowerCase() === 'tencent') {
      return false;
    }

    return true;
  };
  const colors = [['activeTextColor', 'text-muted', 'nonActiveTextColor', 'text-muted', 'text-muted'],
    ['nonActiveTextColor', 'text-muted', 'nonActiveTextColor', 'text-muted', 'text-muted'],
    ['nonActiveTextColor', 'text-muted', 'activeTextColor', 'text-muted', 'text-muted'],
    ['nonActiveTextColor', 'text-muted', 'nonActiveTextColor', 'text-muted', 'text-muted'],
    ['nonActiveTextColor', 'text-muted', 'nonActiveTextColor', 'text-muted', 'text-muted']];
  const [color, setColor] = useState(colors[0]);
  const getCloudName = (name:string):string => {
    if (name.toLowerCase() === 'aws') return 'AWS';
    if (name.toLowerCase() === 'gcp') return 'GCP';
    if (name.toLowerCase() === 'digitalocean' || name.toLowerCase() === 'digital ocean') return 'DigitalOcean';
    if (name.toLowerCase() === 'tencent') return 'Tencent Cloud';
    return name;
  };
  return (
    <div
      className="tab-pane fade show active"
    >
      <nav className="col-xl-9 col-lg-12 col-md-12 col-sm-12 mt-5">
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          {cloudTab.length === 0 && <p>No Cloud Available</p>}
          {cloudTab.map((data, idx) => (
              <button
                className="nav-link createButton"
                id="nav-home-tab"
                // eslint-disable-next-line react/no-array-index-key
                key={idx.toString()}
                type="button"
                disabled={setDisable(data.name)}
                onClick={() => { setCloudInfo(data.id, data.name); setColor(colors[idx]); }}
                style={{ color: color[idx] }}
              >
                <img src={getImage(data.name)} style={{ marginRight: '10px' }} alt="" />
                <span className={color[idx]}>
{
                getCloudName(data.name)

                }

                </span>
              </button>
          ))}

        </div>
      </nav>
      <div
        className="tab-content col-xl-11 col-lg-10 col-md-12 col-sm-12 mt-3"
        id="nav-tabContent"
      >
        {setCloudData()}

      </div>
    </div>
  );
};
export default MyCloud;
